import React from 'react';
import { useCollection } from '../data/firestore';
import { useAuth, signOut } from '../AuthContext';
import { MarkdownLite } from './Plan';

// Full-spec internal pricing (/pricing-internal) — PRIVATE companion to the
// public /pricing page: node license fees, discount percentages, true-up
// mechanics, worked examples, competitive intel. Content lives in the
// Firestore `pricingSections` collection (allowlist-gated in rules, same
// pattern as /plan, /docs, /idp-pricing); this page is just the viewer.
export default function PricingInternal() {
  const { user } = useAuth();
  const { docs: sections, error } = useCollection('pricingSections', {
    orderBy: 'order',
    dir: 'asc',
  });

  if (error) {
    const denied = /permission/i.test(error);
    return (
      <div className="cs-page">
        <div className="cs-empty" style={{ maxWidth: 520 }}>
          {denied ? (
            <>
              <p style={{ marginTop: 0 }}>
                <strong>{user?.email}</strong> isn't approved for the internal
                pricing spec. Access is invite-only — contact Nventr to have
                your email added.
              </p>
              <button className="cs-btn cs-btn-outline cs-btn-sm" onClick={() => signOut()}>
                Sign out
              </button>
            </>
          ) : (
            <>Couldn't load the pricing spec: {error}</>
          )}
        </div>
      </div>
    );
  }
  if (sections === null) {
    return (
      <div className="cs-page">
        <div className="cs-empty">Loading the pricing spec…</div>
      </div>
    );
  }

  return (
    <div className="cs-page cs-plan">
      <h1>Platform Pricing — Full Internal Spec</h1>
      <p className="cs-store-note">
        The three-meter model with everything the public /pricing page holds
        back: license fees, discounts, true-up mechanics, worked examples,
        competitive intel · Confidential — internal & NDA enterprise
        engagements only · August 2026.
      </p>

      <nav className="cs-plan-toc">
        {sections.map((s) => (
          <a key={s.id} href={`#${s.id}`}>{s.title}</a>
        ))}
      </nav>

      {sections.map((s) => (
        <section key={s.id} id={s.id} className="cs-plan-section">
          <h2>{s.title}</h2>
          <MarkdownLite text={s.body} />
        </section>
      ))}
    </div>
  );
}
